import { AxiosRequestConfig } from 'axios';
import { v4 as uuidv4 } from 'uuid';

export const CORRELATION_ID_HEADER = 'X-Correlation-ID';

const createCorrelationId = (): string => uuidv4().replace(/-/g, '');

const findHeaderKey = (
  headers: Record<string, unknown>,
  headerName: string
): string | undefined =>
  Object.keys(headers).find(
    (key) => key.toLowerCase() === headerName.toLowerCase()
  );

export const ensureCorrelationIdHeader = (
  headers: AxiosRequestConfig['headers']
): AxiosRequestConfig['headers'] => {
  const nextHeaders = {
    ...(headers || {}),
  } as Record<string, unknown>;

  const existingKey = findHeaderKey(nextHeaders, CORRELATION_ID_HEADER);
  const existingValue = existingKey ? nextHeaders[existingKey] : undefined;

  nextHeaders[CORRELATION_ID_HEADER] =
    typeof existingValue === 'string' && existingValue.trim()
      ? existingValue
      : createCorrelationId();

  return nextHeaders as AxiosRequestConfig['headers'];
};
